<template>
    <v-card>
        <v-card-title>
            Upload Offline Images
        </v-card-title>
        <v-divider />
        <v-card-text>
            <div class="text-center mt-4">
                <v-icon
                    v-if="completedSuccessfully"
                    color="#49C84F"
                    size="50px"
                >
                    check_circle
                </v-icon>
                <v-progress-circular
                    v-else
                    :value="progress"
                    :size="60"
                    color="#122448"
                    :rotate="90"
                >
                    <span class="progress-text">
                        {{ progress }}%
                    </span>
                </v-progress-circular>
                <div
                    v-if="completedSuccessfully"
                    class="upload-progress-subtext successfull my-4"
                >
                    Offline Images Uploaded Successfully!
                </div>
                <div
                    v-else
                    class="upload-progress-subtext my-4"
                >
                    Uploading Images
                </div>
            </div>
            <v-spacer />
            <div
                class="table-label"
            >
                Images
            </div>
            <v-data-table
                :headers="offlineImagesTableHeaders"
                :items="offlineImages"
                item-key="member"
                hide-default-footer
                class="mt-2 mb-6"
                mobile-breakpoint="0"
            />
        </v-card-text>
        <v-divider />
        <v-card-actions>
            <v-spacer />
            <v-btn
                style="text-transform: none !important"
                class="text-subtitle-2"
                outlined
                :width="this.$vuetify.breakpoint.xs ? '140px' : '76px'"
                @click="cancel"
            >
                Cancel
            </v-btn>
            <v-btn
                style="text-transform: none !important"
                class="text-subtitle-2"
                :disabled="disableDone"
                depressed
                color="primary"
                :width="this.$vuetify.breakpoint.xs ? '140px' : '76px'"
                @click="close"
            >
                Done
            </v-btn>
            <v-spacer v-if="this.$vuetify.breakpoint.xs" />
        </v-card-actions>
    </v-card>
</template>
<script>
export default {
    props: {
    },
    data: () => ({
        offlineImagesTableHeaders: [
            {
                text: 'Code',
                value: 'code'
            },
            {
                text: 'Caption',
                value: 'caption'
            },
            {
                text: 'File Type',
                value: 'fileType'
            },
            {
                text: 'Status',
                value: 'status'
            },

        ],
    }),
    computed: {
        showDialog: {
            get() {
                return this.show;                
            },
            set() {
                this.$store.commit('SET_OFFLINE_IMAGES_STATUSES', []);
                this.close();
            },
        },
        offlineImages() {
            return this.$store.getters.offlineImageStatuses;
        },
        disableDone() {
            return !this.completedSuccessfully;
        },
        succeededCount() {
            return this.offlineImages.filter(image => image.status === 'succeeded').length;
        },
        progressCount() {
            return this.offlineImages.filter(image => !!image.status).length;
        },
        completedSuccessfully() {
            return this.offlineImages.length > 0 && this.succeededCount === this.offlineImages.length;
        },
        progress() {
            return this.offlineImages.length === 0 ? 0 : Math.floor((this.progressCount/this.offlineImages.length) * 100);
        },
    },
    methods: {
        cancel() {
            this.close();
        },
        close() {
            this.$emit('close-dialog');
        },
    },
};
</script>
